import { useEffect, useState } from "react";
import "./SnsLoginCallbackPage.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";


const SnsLoginCallbackPage = () => {
    const navigate = useNavigate();
    const { login, isLoggedIn } = useAuth();

    useEffect(() => {
        if (window.location.pathname !== "/login/callback") {
            return;
        }

        if (isLoggedIn) {
            navigate("/", { replace: true });
            return;
        }

        const params = new URLSearchParams(window.location.search);

        const error = params.get("error");
        const message = params.get("message");

        if (error) {
            if (error === "access_denied") {
                navigate("/login", { replace: true });
                return;
            }

            console.error("SNS login failed:", error, message);
            navigate("/login", { replace: true, state: { error: message || "Unknown SNS login error" } });
            return;
        }

        const accessToken = params.get("accessToken");
        const refreshToken = params.get("refreshToken");
        const email = params.get("email");
        const authorityType = params.get("authorityType");
        const isNewAccount = params.get("newAccount") === "true";

        // console.log("href", window.location.href);
        // console.log("search", window.location.search);
        // console.log("hash", window.location.hash);

        if (!accessToken || !refreshToken || !email || !authorityType) {
            navigate("/login", { replace: true, state: { error: "Login callback is missing data." } });
            return;
        }

        login({
            accessToken: accessToken,
            refreshToken: refreshToken,
            authorityType: authorityType,
            email: email,
        });

        if (isNewAccount) {
            navigate(
                "/login/create-password", 
                { 
                    replace: true,
                    state: { fromCallback: true },
                }
            );
        }
        else {
            navigate("/", { replace: true });
        }
    }, [navigate]);

    return null;
};

export default SnsLoginCallbackPage;